import {
  Box,
  Flex,
  HStack,
  Heading,
  IconButton,
  Tag,
  TagLabel,
  Text,
  Tooltip,
  Wrap,
  WrapItem,
} from '@chakra-ui/react'
import { Trans, t } from '@lingui/macro'
import { FC } from 'react'
import { MdCopyAll, MdDelete, MdEdit } from 'react-icons/md'

type Props = {
  queues: string[]
  prompt: string
  handleOpenModal: () => void
  handleDeleteQueuePromptPair: () => void
  handleDuplicateQueuePromptPair: () => void
  duplicatedQueues: Set<string>
}

export const QueueAndPrompts: FC<Props> = ({
  queues,
  prompt,
  handleOpenModal,
  handleDeleteQueuePromptPair,
  handleDuplicateQueuePromptPair,
  duplicatedQueues,
}) => {
  const isDuplicated = queues.some((q) => duplicatedQueues.has(q))
  return (
    <Box position="relative" w="100%">
      <Flex
        border="1px"
        borderRadius="md"
        p={2}
        minH="100px"
        flexDirection="column"
        gap={4}
        borderColor={isDuplicated ? 'red.500' : 'gray.200'}
      >
        <Box>
          <Heading fontWeight="medium" color="gray.600" mb={1}>
            <Trans>Queues</Trans>
          </Heading>
          <Wrap spacing={2}>
            {queues.map((queue, index) => {
              const isDuplicated = duplicatedQueues.has(queue)
              return (
                <Tooltip
                  isDisabled={!isDuplicated}
                  key={index}
                  hasArrow
                  placement="top"
                  label={t`This queue is duplicated. Remove it or its duplicate(s) to be able to save.`}
                >
                  <WrapItem>
                    <Tag
                      size="md"
                      borderRadius="full"
                      colorScheme={isDuplicated ? 'red' : 'gray'}
                    >
                      <TagLabel>{queue}</TagLabel>
                    </Tag>
                  </WrapItem>
                </Tooltip>
              )
            })}
          </Wrap>
        </Box>
        <Box>
          <Heading size="md">
            <Trans>Prompt</Trans>
          </Heading>
          <Text>{prompt}</Text>
        </Box>
        <HStack position="absolute" top={2} right={2} spacing={1}>
          <IconButton
            aria-label="Copy paste prompt and queue block"
            icon={<MdCopyAll />}
            size="sm"
            variant="ghost"
            onClick={handleDuplicateQueuePromptPair}
          />
          <IconButton
            aria-label="Delete queues"
            icon={<MdDelete />}
            size="sm"
            variant="ghost"
            onClick={handleDeleteQueuePromptPair}
          />
          <IconButton
            aria-label="Edit queues"
            icon={<MdEdit />}
            size="sm"
            variant="ghost"
            onClick={handleOpenModal}
          />
        </HStack>
      </Flex>
    </Box>
  )
}
